import React, { useState } from "react"
import { Modal } from "react-bootstrap"
import { useTranslation } from "react-i18next"

import {
  Button,
  Select,
  DatePickerWithInput,
  UsersSelectFilter,
  BranchSelectFilter,
  PaymentSelectFilter
} from "components"
import { deliveryTypeLabels } from "constants"
import classes from "./OrdersHeaderModal.module.scss"

const initialFormState = {
  fromDate: "",
  toDate: "",
  paymentTypes: [],
  branchId: "",
  deliveryType: "",
  addedBySystem: null,
  selectedAccount: null
}

const OrdersHeaderModal = (props) => {
  const {
    filters,
    setFilters,
    openModal,
    setOpenModal
  } = props

  const [t] = useTranslation()

  const [form, setForm] = useState(initialFormState)

  const handleChange = (value, name) => {
    setForm(prev => ({ ...prev, [name]: value }))
  }

  const handleChangeDate = (range) => {
    setForm(prev => ({
      ...prev,
      fromDate: range[0],
      toDate: range[1]
    }))
  }

  const handleApply = () => {
    setFilters({ ...form })

    setOpenModal(false)
  }

  const deliveryTypeOptions =
    Object.keys(deliveryTypeLabels).map(deliveryType => ({
      label: deliveryTypeLabels[deliveryType],
      value: deliveryType
    }))

  const addedBySystemOptions = [
    { label: "پرسنل", value: true },
    { label: "سایت", value: false }
  ]

  const addedBySystemSelectValue =
    form.addedBySystem !== null
      ?
      {
        label: form.addedBySystem ? "پرسنل" : "سایت",
        value: form.addedBySystem
      }
      : null

  const deliveryTypeSelectValue =
    deliveryTypeOptions.find(deliveryTypeOption =>
      deliveryTypeOption.value === form.deliveryType
    )

  return (
    <Modal
      centered
      backdrop="static"
      show={openModal}
      onEnter={() => setForm({ ...filters })}
      onHide={() => setOpenModal(false)}
      onExited={() => setForm({ ...initialFormState })}
    >
      <div className={classes["container"]}>
        <UsersSelectFilter
          role="user"
          label={t("مشتریان")}
          placeholder={t("مشتریان_را_جست_و_جو_کنید")}
          className={classes["input"]}
          onChange={select => handleChange(select, "selectedAccount")}
          value={form.selectedAccount}
        />

        <UsersSelectFilter
          role="access"
          label={t("پرسنل")}
          placeholder={t("پرسنل_را_جست_و_جو_کنید")}
          className={classes["input"]}
          onChange={select => handleChange(select, "addedByAccount")}
          value={form.addedByAccount}
        />

        <PaymentSelectFilter
          isMulti
          isClearable
          className={classes["input"]}
          onChange={(select) => handleChange(select, "paymentTypes")}
          value={form.paymentTypes}
        />

        <DatePickerWithInput
          isClearable
          type="rangeDatePicker"
          label={t("تاریخ_ایجاد_سفارش")}
          placeholder={t("بازه_زمانی_را_انتخاب_کنید")}
          maxDate={new Date().toISOString()}
          className={classes["input"]}
          onChange={handleChangeDate}
          range={!!form.fromDate ? [form.fromDate, form.toDate] : []}
        />

        <BranchSelectFilter
          className={classes["input"]}
          onChange={(select) => handleChange(select?.value || "", "branchId")}
          value={filters.branchId}
        />

        <Select
          isSearchable={false}
          isClearable
          label={t("طریق_سفارش")}
          placeholder={t("طریق_سفارش_را_انتخاب_کنید")}
          noOptionsMessage={() => null}
          className={classes["input"]}
          options={addedBySystemOptions}
          value={addedBySystemSelectValue}
          onChange={(select) =>
            handleChange(select?.value !== undefined ? select.value : null, "addedBySystem")
          }
        />

        <Select
          isClearable
          isSearchable={false}
          label={t("نوع_تحویل")}
          placeholder={t("نوع_تحویل_را_انتخاب_کنید")}
          options={deliveryTypeOptions}
          value={deliveryTypeSelectValue}
          className={classes["input"]}
          onChange={(select) => handleChange(select?.value, "deliveryType")}
        />

        <div className={classes["footer"]}>
          <Button
            color="danger"
            className={classes["button"]}
            onClick={() => setOpenModal(false)}
          >
            {t("انصراف")}
          </Button>

          <Button
            onClick={handleApply}
            color="success"
          >
            {t("اعمال")}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default OrdersHeaderModal